import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowLeft } from "lucide-react";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function Login() {
  const handleGoogleLogin = () => {
    const redirectUrl = window.location.origin + "/dashboard";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="min-h-screen bg-cream grid md:grid-cols-2">
      {/* Left visual */}
      <div className="hidden md:block relative overflow-hidden">
        <img
          src="https://images.unsplash.com/photo-1635388134853-d5ae4f76902a?w=1600&q=80"
          alt=""
          className="absolute inset-0 w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-br from-cream/40 via-transparent to-ink/40" />
        <div className="absolute bottom-10 left-10 right-10 text-cream">
          <p className="overline text-warmgold">Fernebia</p>
          <p className="script text-5xl mt-3">Invitaciones que enamoran al scroll</p>
          <p className="mt-4 max-w-md text-cream/90">Crea, comparte y recibe confirmaciones en un panel privado — solo para ti.</p>
        </div>
      </div>

      {/* Right form */}
      <div className="flex flex-col justify-center px-8 md:px-16 py-16 relative">
        <Link to="/" className="btn-ghost self-start" data-testid="login-back-home">
          <ArrowLeft size={16} /> Volver al inicio
        </Link>

        <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6 }} className="mt-12 max-w-md">
          <p className="overline">Acceso de administrador</p>
          <h1 className="headline text-5xl md:text-6xl text-ink mt-4 leading-tight">
            Panel de
            <span className="script text-warmgold text-6xl md:text-7xl ml-3">Fernebia</span>
          </h1>
          <p className="text-inksoft mt-6 leading-relaxed">
            Acceso exclusivo del administrador para gestionar las invitaciones de los clientes. ¿Quieres una invitación? Escríbenos por WhatsApp o Instagram desde la página principal y la diseñamos por ti.
          </p>

          <button
            onClick={handleGoogleLogin}
            data-testid="google-login-btn"
            className="mt-10 w-full inline-flex items-center justify-center gap-3 rounded-full bg-white border border-warmgold/30 text-ink py-4 px-6 font-medium shadow-sm hover:shadow-md hover:-translate-y-0.5 transition-all duration-300"
          >
            <svg width="18" height="18" viewBox="0 0 24 24">
              <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" />
              <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" />
              <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" />
              <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" />
            </svg>
            Continuar con Google
          </button>

          <p className="mt-8 text-xs text-inksoft leading-relaxed">
            Solo cuentas autorizadas pueden ingresar. Los clientes nos contactan por WhatsApp o Instagram.
          </p>
        </motion.div>
      </div>
    </div>
  );
}
